import {
  CLEAR_CARE_HEARTH_FEEDBACK,
  CREATE_CARE_HEARTH_OFFERS,
  CREATE_CARE_HEARTH_OFFERS_FAILURE,
  CREATE_CARE_HEARTH_OFFERS_SUCCESS,
  DECIDE_CARE_HEARTH_DISPUTE,
  DECIDE_CARE_HEARTH_DISPUTE_FAILURE,
  DECIDE_CARE_HEARTH_DISPUTE_SUCCESS,
  FETCH_CARE_HEARTH_ENQUIRIES,
  FETCH_CARE_HEARTH_ENQUIRIES_FAILURE,
  FETCH_CARE_HEARTH_ENQUIRIES_SUCCESS,
  FETCH_CARE_HEARTH_ENQUIRY,
  FETCH_CARE_HEARTH_ENQUIRY_FAILURE,
  FETCH_CARE_HEARTH_ENQUIRY_SUCCESS,
  FETCH_CARE_HEARTH_SEARCHES,
  FETCH_CARE_HEARTH_SEARCHES_FAILURE,
  FETCH_CARE_HEARTH_SEARCHES_SUCCESS,
  FETCH_CARE_HEARTH_AUDIT_EVENTS,
  FETCH_CARE_HEARTH_AUDIT_EVENTS_FAILURE,
  FETCH_CARE_HEARTH_AUDIT_EVENTS_SUCCESS,
  FIND_CARE_HEARTH_ELIGIBLE_HOMES,
  FIND_CARE_HEARTH_ELIGIBLE_HOMES_FAILURE,
  FIND_CARE_HEARTH_ELIGIBLE_HOMES_SUCCESS,
  RECORD_CARE_HEARTH_SEARCH_CALL,
  RECORD_CARE_HEARTH_SEARCH_CALL_FAILURE,
  RECORD_CARE_HEARTH_SEARCH_CALL_SUCCESS,
  START_CARE_HEARTH_SEARCH_ENQUIRY,
  START_CARE_HEARTH_SEARCH_ENQUIRY_FAILURE,
  START_CARE_HEARTH_SEARCH_ENQUIRY_SUCCESS,
  UPDATE_CARE_HEARTH_LIFECYCLE,
  UPDATE_CARE_HEARTH_LIFECYCLE_FAILURE,
  UPDATE_CARE_HEARTH_LIFECYCLE_SUCCESS,
  UPDATE_CARE_HEARTH_VERIFICATION,
  UPDATE_CARE_HEARTH_VERIFICATION_FAILURE,
  UPDATE_CARE_HEARTH_VERIFICATION_SUCCESS,
} from "./constants";

const action = (type) => (payload) => ({ type, payload });

export const fetchCareHearthEnquiries = action(FETCH_CARE_HEARTH_ENQUIRIES);
export const fetchCareHearthEnquiriesSuccess = action(
  FETCH_CARE_HEARTH_ENQUIRIES_SUCCESS,
);
export const fetchCareHearthEnquiriesFailure = action(
  FETCH_CARE_HEARTH_ENQUIRIES_FAILURE,
);

export const fetchCareHearthEnquiry = action(FETCH_CARE_HEARTH_ENQUIRY);
export const fetchCareHearthEnquirySuccess = action(
  FETCH_CARE_HEARTH_ENQUIRY_SUCCESS,
);
export const fetchCareHearthEnquiryFailure = action(
  FETCH_CARE_HEARTH_ENQUIRY_FAILURE,
);

export const fetchCareHearthAuditEvents = action(
  FETCH_CARE_HEARTH_AUDIT_EVENTS,
);
export const fetchCareHearthAuditEventsSuccess = action(
  FETCH_CARE_HEARTH_AUDIT_EVENTS_SUCCESS,
);
export const fetchCareHearthAuditEventsFailure = action(
  FETCH_CARE_HEARTH_AUDIT_EVENTS_FAILURE,
);

export const findCareHearthEligibleHomes = action(
  FIND_CARE_HEARTH_ELIGIBLE_HOMES,
);
export const findCareHearthEligibleHomesSuccess = action(
  FIND_CARE_HEARTH_ELIGIBLE_HOMES_SUCCESS,
);
export const findCareHearthEligibleHomesFailure = action(
  FIND_CARE_HEARTH_ELIGIBLE_HOMES_FAILURE,
);

export const createCareHearthOffers = action(CREATE_CARE_HEARTH_OFFERS);
export const createCareHearthOffersSuccess = action(
  CREATE_CARE_HEARTH_OFFERS_SUCCESS,
);
export const createCareHearthOffersFailure = action(
  CREATE_CARE_HEARTH_OFFERS_FAILURE,
);

export const updateCareHearthLifecycle = action(UPDATE_CARE_HEARTH_LIFECYCLE);
export const updateCareHearthLifecycleSuccess = action(
  UPDATE_CARE_HEARTH_LIFECYCLE_SUCCESS,
);
export const updateCareHearthLifecycleFailure = action(
  UPDATE_CARE_HEARTH_LIFECYCLE_FAILURE,
);

export const updateCareHearthVerification = action(
  UPDATE_CARE_HEARTH_VERIFICATION,
);
export const updateCareHearthVerificationSuccess = action(
  UPDATE_CARE_HEARTH_VERIFICATION_SUCCESS,
);
export const updateCareHearthVerificationFailure = action(
  UPDATE_CARE_HEARTH_VERIFICATION_FAILURE,
);

// payload: { uuid, disputeUuid, decision: "approve" | "reject", note }
export const decideCareHearthDispute = action(DECIDE_CARE_HEARTH_DISPUTE);
export const decideCareHearthDisputeSuccess = action(
  DECIDE_CARE_HEARTH_DISPUTE_SUCCESS,
);
export const decideCareHearthDisputeFailure = action(
  DECIDE_CARE_HEARTH_DISPUTE_FAILURE,
);

// Not sent (15 October 2026). payload: { page, per_page, search }
export const fetchCareHearthSearches = action(FETCH_CARE_HEARTH_SEARCHES);
export const fetchCareHearthSearchesSuccess = action(
  FETCH_CARE_HEARTH_SEARCHES_SUCCESS,
);
export const fetchCareHearthSearchesFailure = action(
  FETCH_CARE_HEARTH_SEARCHES_FAILURE,
);

// payload: { uuid, outcome: "reached" | "no_answer" | "wrong_number" |
// "not_interested", note }
export const recordCareHearthSearchCall = action(
  RECORD_CARE_HEARTH_SEARCH_CALL,
);
export const recordCareHearthSearchCallSuccess = action(
  RECORD_CARE_HEARTH_SEARCH_CALL_SUCCESS,
);
export const recordCareHearthSearchCallFailure = action(
  RECORD_CARE_HEARTH_SEARCH_CALL_FAILURE,
);

// payload: { uuid, note }
export const startCareHearthSearchEnquiry = action(
  START_CARE_HEARTH_SEARCH_ENQUIRY,
);
export const startCareHearthSearchEnquirySuccess = action(
  START_CARE_HEARTH_SEARCH_ENQUIRY_SUCCESS,
);
export const startCareHearthSearchEnquiryFailure = action(
  START_CARE_HEARTH_SEARCH_ENQUIRY_FAILURE,
);

export const clearCareHearthFeedback = action(CLEAR_CARE_HEARTH_FEEDBACK);
